export default function combinePaths(...paths: string[]) {
  const trimmedPaths = paths
    .map(path => {
      let trimmedPath = path
      if (trimmedPath.startsWith('/')) trimmedPath = trimmedPath.slice(1)
      if (trimmedPath.endsWith('/')) trimmedPath = trimmedPath.slice(0, -1)
      return trimmedPath
    })
    .filter(Boolean)

  let combinedPath = trimmedPaths.join('/')
  if (!combinedPath.startsWith('/')) combinedPath = '/' + combinedPath

  return combinedPath
}
